<section class="md:h-screen py-36 flex items-center bg-[url('../../assets/images/cta.jpg')] bg-no-repeat bg-center">
  <div class="absolute top-0 start-0 w-full h-full z-0 pointer-events-none overflow-hidden">
    <iframe src="https://player.vimeo.com/video/235428555?background=1&autoplay=1&loop=1&byline=0&title=0" class="absolute top-1/2 start-1/2 ltr:-translate-x-1/2 rtl:translate-x-1/2 -translate-y-1/2 w-screen h-[56.25vw] min-h-screen min-w-[177.77vw]"></iframe>
  </div>
  <div class="absolute inset-0 bg-gradient-to-b from-transparent to-black"></div>
  <div class="container">
    <div class="flex justify-center">
      <div class="max-w-[400px] w-full m-auto p-6 bg-white dark:bg-slate-900 shadow-md dark:shadow-gray-800 rounded-md">
        <a [routerLink]="'/'">
          <img [src]="'assets/images/logo-dark.png'" class="mx-auto h-7 block dark:hidden" alt="">
          <img [src]="'assets/images/logo-light.png'" class="mx-auto h-7 dark:block hidden" alt="">
        </a>
        <h5 class="my-6 text-xl font-semibold">{{ "SIGNUP.TITLE" | translate }}</h5>
        <!-- Error message display -->
        <div *ngIf="errorMessage" class="my-4 p-3 bg-red-100 text-red-700 rounded-md">
          {{ errorMessage | translate }}
        </div>
        <form class="text-start" [formGroup]="signUpForm" (ngSubmit)="onSignUpSubmit()">
          <div class="grid grid-cols-1">
            <div class="mb-4">
              <label class="font-semibold" for="RegisterName">{{ 'SIGNUP.YOUR_NAME' | translate }}:</label>
              <input id="RegisterName" formControlName="realName" type="text" class="form-input w-full text-[15px] py-2 px-3 h-10 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded-full outline-none border border-gray-200 focus:border-violet-600 dark:border-gray-800 dark:focus:border-violet-600 focus:ring-0 mt-3" placeholder="Harry">
              <div *ngIf="signUpForm.get('realName')?.invalid && signUpForm.get('realName')?.touched" class="text-red-500 text-sm mt-1">
                {{ 'SIGNUP.ERROR.INVALID_NAME' | translate }}
              </div>
            </div>

            <div class="mb-4">
              <label class="font-semibold" for="RegisterName">{{ 'SIGNUP.USERNAME' | translate }}:</label>
              <input id="RegisterUserName" formControlName="userName" type="text" class="form-input w-full text-[15px] py-2 px-3 h-10 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded-full outline-none border border-gray-200 focus:border-violet-600 dark:border-gray-800 dark:focus:border-violet-600 focus:ring-0 mt-3" placeholder="Harry312">
              <div *ngIf="signUpForm.get('userName')?.invalid && signUpForm.get('userName')?.touched" class="text-red-500 text-sm mt-1">
                {{ 'SIGNUP.ERROR.INVALID_USERNAME' | translate }}
              </div>
            </div>

            <div class="mb-4">
              <label class="font-semibold" for="LoginEmail">{{ 'SIGNUP.EMAIL' | translate }}:</label>
              <input id="LoginEmail" type="email" formControlName="email" class="form-input w-full text-[15px] py-2 px-3 h-10 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded-full outline-none border border-gray-200 focus:border-violet-600 dark:border-gray-800 dark:focus:border-violet-600 focus:ring-0 mt-3" placeholder="name@example.com">
              <div *ngIf="signUpForm.get('email')?.invalid && signUpForm.get('email')?.touched" class="text-red-500 text-sm mt-1">
                {{ 'SIGNUP.ERROR.INVALID_EMAIL' | translate }}
              </div>
            </div>

            <div class="mb-4">
              <label class="font-semibold" for="LoginPassword">{{ 'SIGNUP.PASSWORD' | translate }}:</label>
              <input id="LoginPassword" type="password" formControlName="password" class="form-input w-full text-[15px] py-2 px-3 h-10 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded-full outline-none border border-gray-200 focus:border-violet-600 dark:border-gray-800 dark:focus:border-violet-600 focus:ring-0 mt-3" placeholder="Password:">
              <div *ngIf="signUpForm.get('password')?.invalid && signUpForm.get('password')?.touched" class="text-red-500 text-sm mt-1">
                {{ 'SIGNUP.ERROR.INVALID_PASSWORD' | translate }}
              </div>
            </div>

            <div class="mb-4">
              <label class="font-semibold" for="LoginBirthDate">{{ 'SIGNUP.BIRTHDATE' | translate }}:</label>
              <input id="LoginBirthDate" type="date" formControlName="birthday" class="form-input w-full text-[15px] py-2 px-3 h-10 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded-full outline-none border border-gray-200 focus:border-violet-600 dark:border-gray-800 dark:focus:border-violet-600 focus:ring-0 mt-3" placeholder="Birthdate:">
              <div *ngIf="signUpForm.get('birthday')?.invalid && signUpForm.get('birthday')?.touched" class="text-red-500 text-sm mt-1">
                {{ 'SIGNUP.ERROR.INVALID_BIRTHDATE' | translate }}
              </div>
            </div>

            <div class="flex items-center mb-4">
              <input formControlName="agreeTerms" class="form-checkbox rounded border-gray-200 dark:border-gray-800 text-violet-600 focus:border-violet-600/30 focus:ring focus:ring-offset-0 focus:ring-violet-600/20 focus:ring-opacity-50 me-2" type="checkbox" value="" id="AcceptT&C">
              <label class="form-checkbox-label text-slate-400" for="AcceptT&C" [innerHTML]="'SIGNUP.ACCEPT_TOS' | translate"></label>
            </div>

            <div *ngIf="signUpForm.get('agreeTerms')?.invalid && signUpForm.get('agreeTerms')?.touched" class="text-red-500 text-sm mt-1">
              {{ 'SIGNUP.ERROR.AGREE_TERMS' | translate }}
            </div>

            <div class="mb-4">
              <button type="submit" class="btn bg-violet-600 hover:bg-violet-700 border-violet-600 hover:border-violet-700 text-white rounded-full w-full" [disabled]="isLoading || signUpForm.invalid || !signUpForm.get('agreeTerms')?.value">
                <span *ngIf="!isLoading">{{ 'SIGNUP.SUBMIT_SIGNUP_BTN' | translate }}</span>
                <span *ngIf="isLoading">{{ 'SIGNUP.SUBMIT_SIGNUP_LOADING_BTN' | translate }}</span>
              </button>
            </div>

            <div class="text-center">
              <span class="text-slate-400 me-2">{{ 'SIGNUP.ALREADY_SIGNIN' | translate }}</span> <a [routerLink]="'/login'" class="text-black dark:text-white font-bold">{{ 'SIGNUP.SIGNIN' | translate }}</a>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</section>

<app-back-to-home/>
<app-switcher/>
